import React, { useState } from 'react';
import { 
  Typography,
  Layout,
  Row,
  Col
} from 'antd';
import PdfViewer from "../../components/shared/PdfViewer";
import {reportService} from "../../services/domain/report/service";

const { Title } = Typography;
const { Content } = Layout;

// Mock data for the table
// const mockData = [
//   {
//     key: '1',
//     memberId: '5000',
//     companyName: 'ABC',
//     memberLevel: 1,
//     capitalAmount: 200,
//     correctedLevel: 3
//   },
//   // You can add more mock data as needed
// ];

const MemberStatisticsPage: React.FC = () => {
  // const [loading, setLoading] = useState(false);
  // const [data, setData] = useState<any[]>([]);
  const [pdfPreviewVisible, setPdfPreviewVisible] = useState(false);

  // const handlePrint = () => {
  //   setLoading(true);
  //
  //   // Simulating a print operation
  //   setTimeout(() => {
  //     message.success('報表已列印');
  //     setLoading(false);
  //   }, 1000);
  // };

  // Table columns configuration
  // const columns = [
  //   {
  //     title: '會員證號',
  //     dataIndex: 'memberId',
  //     key: 'memberId',
  //     width: 150,
  //     align: 'center' as const,
  //   },
  //   {
  //     title: '公司名稱',
  //     dataIndex: 'companyName',
  //     key: 'companyName',
  //     align: 'center' as const,
  //   },
  //   {
  //     title: '會員級數',
  //     dataIndex: 'memberLevel',
  //     key: 'memberLevel',
  //     width: 150,
  //     align: 'center' as const,
  //   },
  //   {
  //     title: '資本額',
  //     dataIndex: 'capitalAmount',
  //     key: 'capitalAmount',
  //     width: 150,
  //     align: 'center' as const,
  //   },
  //   {
  //     title: '修正級數',
  //     dataIndex: 'correctedLevel',
  //     key: 'correctedLevel',
  //     width: 150,
  //     align: 'center' as const,
  //   },
  // ];

  // 關閉PDF預覽視窗
  const handleClosePdfPreview = () => {
    setPdfPreviewVisible(false);
  };

  const handleLoadPdfData = async () => {
    return  await reportService.getMembershipOrganizationPdf();
  }

  /**
   * Export PDF
   */
  const exportPdf = async (filename: string) => {
    // In production, we would handle different report types here
    await reportService.exportMembershipOrganizationPdf();
  };

  /**
   * Export Excel
   */
  const exportExcel = async (filename: string) => {
    // In production, we would handle different report types here
    await reportService.exportMembershipOrganizationExcel();
  };

  return (
    <Layout className="member-statistics-page">
      <Content>
        {/* Page Title and Button */}
        <Row justify="center" className="mb-lg">
          <Col>
            <Title level={3} className="membership-title-with-emoji">
              會員組織統計
            </Title>
          </Col>
        </Row>
        {/*<Row justify="end" className="mb-lg">*/}
        {/*  <Col>*/}
        {/*    <Button*/}
        {/*        type="primary"*/}
        {/*        icon={<PrinterOutlined/>}*/}
        {/*        loading={loading}*/}
        {/*        onClick={() => {*/}
        {/*          setPdfPreviewVisible(true);*/}
        {/*        }}*/}
        {/*    >*/}
        {/*      預覽報表*/}
        {/*    </Button>*/}
        {/*  </Col>*/}
        {/*</Row>*/}
        {/* Main Table */}
        {/*<Card>*/}
        {/*  <Table*/}
        {/*    columns={columns}*/}
        {/*    dataSource={data}*/}
        {/*    pagination={false}*/}
        {/*    bordered*/}
        {/*    size="middle"*/}
        {/*    loading={loading}*/}
        {/*    style={{ width: '100%' }}*/}
        {/*    rowClassName={() => "editable-row"}*/}
        {/*  />*/}
        {/*</Card>*/}

        {/* PDF預覽視窗 */}
        <PdfViewer
            mode='general'
            visible={pdfPreviewVisible}
            onClose={handleClosePdfPreview}
            title="比價證明書預覽"
            loadPdfData={handleLoadPdfData}
            exportPdf={exportPdf}
            exportExcel={exportExcel}
        />

      </Content>
    </Layout>
  );
};

export default MemberStatisticsPage;
